/* HUMANCORE: Gratis-E-Book automatisch zum Ring in den Warenkorb */
(function(){
  var RING=16583076872582, EBV=67572309655942, busy=false, last=null, again=false;
  var st=document.createElement('style');
  st.textContent='.hc-bl quantity-input,.hc-bl cart-remove-button{display:none!important}.hc-bl__n{display:inline-block;margin-top:6px;padding:3px 9px;border-radius:999px;background:#e9f6ee;color:#17603a;font-size:12px;font-weight:600;line-height:1.3}.hc-bonus__val{display:block;margin-top:6px;font-size:13px}.hc-bonus__val s{color:#8a8a8a;margin:0 3px}.hc-bonus__val b{display:inline!important;color:#c0392b!important;font-size:inherit;margin:0}.hc-bonus__val s{display:inline}';
  document.head.appendChild(st);
  function post(url,body){return fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)}).then(function(r){return r.json()})}
  function scan(c){var o={ring:0,bonus:null,plain:null,idx:-1};(c.items||[]).forEach(function(i,n){if(i.product_id===RING)o.ring+=i.quantity;if(i.variant_id===EBV){if(i.properties&&i.properties._bonus){o.bonus=i;o.idx=n}else o.plain=i}});return o}
  function mark(){
    if(!last)return; var o=scan(last);
    document.querySelectorAll('.hc-bl').forEach(function(r){r.classList.remove('hc-bl')});
    if(o.idx<0)return;
    document.querySelectorAll('#CartDrawer-Item-'+(o.idx+1)+',#CartItem-'+(o.idx+1)).forEach(function(r){
      r.classList.add('hc-bl');
      var d=r.querySelector('.cart-item__details');
      if(d&&!d.querySelector('.hc-bl__n')){var s=document.createElement('span');s.className='hc-bl__n';s.textContent='Gratis zu deinem Ring · PDF per E-Mail';d.appendChild(s)}
      if(r.parentNode&&r.nextElementSibling)r.parentNode.appendChild(r);
    });
    document.querySelectorAll('.cart-item:not(.hc-bl) .discounts__discount').forEach(function(li){if(li.textContent.indexOf('Gratis-Bonus')>-1)li.style.display='none'});
  }
  function refresh(res){
    var dr=document.querySelector('cart-drawer');
    if(dr&&dr.renderContents&&res.sections){
      try{dr.renderContents({id:null,sections:res.sections},false)}catch(e){console.error(e)}
      if(typeof res.item_count==='number')dr.classList.toggle('is-empty',res.item_count===0);
      var ov=dr.querySelector('#CartDrawer-Overlay'); if(ov)ov.addEventListener('click',dr.close.bind(dr));
    }
    try{publish(PUB_SUB_EVENTS.cartUpdate,{source:'hc-bonus',cartData:{sections:res.sections||{}}})}catch(_){}
  }
  async function check(){
    if(busy){again=true;return} busy=true;
    try{
      var c=await fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()});
      last=c; var o=scan(c), res=null, sec=['cart-drawer','cart-icon-bubble'];
      if(o.ring>0&&!o.bonus&&!o.plain){res=await post('/cart/add.js',{items:[{id:EBV,quantity:1,properties:{_bonus:'1'}}],sections:sec,sections_url:location.pathname})}
      else if(o.bonus&&(o.ring===0||o.bonus.quantity!==1)){res=await post('/cart/change.js',{id:o.bonus.key,quantity:o.ring===0?0:1,sections:sec,sections_url:location.pathname})}
      if(res&&!res.status){last=await fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()});refresh(res)}
    }catch(e){console.error(e)}
    finally{busy=false;mark();if(again){again=false;setTimeout(check,50)}}
  }
  var t; new MutationObserver(function(){clearTimeout(t);t=setTimeout(mark,60)}).observe(document.documentElement,{childList:true,subtree:true});
  function init(){
    try{subscribe(PUB_SUB_EVENTS.cartUpdate,function(e){if(e&&e.source==='hc-bonus')return;check()})}catch(_){}
    check();
  }
  if(document.readyState==='complete')init();else document.addEventListener('DOMContentLoaded',init);
})();
